export enum Page {
  Master,
  Faturalar,
  Irsaliyeler,
  Siparisler,
  Teklifler,
  Cariler,
  TalepOnayTurleri,
  UrunGruplar,
  TalepTurler,
  Subeler,
  Giris,
  Anasayfa,
  Kullanicilar,
  KullaniciGruplari,
  Talepler,
  Lojistikler
  // apide helpers  ın içindeki ile aynı olsun
}
